// filepath: c:\Users\barto\Desktop\invayt\web-app\src\components\ui\badge.tsx
import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "../../lib/shadcn"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:bg-primary/80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:bg-secondary/80",
        approved:
          "border-transparent bg-green-100 text-green-700 hover:bg-green-200",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:bg-destructive/80",
        outline: "text-foreground",
        pending:
          "bg-yellow-50 text-yellow-700 border-yellow-200 hover:bg-yellow-100",
        sent:
          "bg-blue-50 text-blue-700 border-blue-200 hover:bg-blue-100",
        accepted:
          "bg-green-50 text-green-700 border-green-200 hover:bg-green-100",
        declined:
          "bg-red-50 text-red-700 border-red-200 hover:bg-red-100",
        purple:
          "bg-primary/10 text-primary border-primary/30 hover:bg-primary/20",
        teal:
          "bg-teal-100 text-teal-700 border-teal-200 hover:bg-teal-200",
        cyan:
          "bg-cyan-100 text-cyan-700 border-cyan-200 hover:bg-cyan-200",
        pink:
          "bg-pink-100 text-pink-700 border-pink-200 hover:bg-pink-200",
        lime:
          "bg-lime-100 text-lime-700 border-lime-200 hover:bg-lime-200",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }